<template lang="pug">
#layer-wc
  .switch-button-name-layer
    switch-toggle.switch-button(ref='switch', :switch-value.sync='isVisible', :switch-id='layerId', @switchValueChanged='toggleLayer')
    .name
      span {{text}}
    .color(:style="{'background-color': color}")
</template>

<script>
import SwitchToggle from './SwitchToggle.vue'

export default {
  name: 'layer',
  props: {
    layerId: Number,
    text: String,
    visible: Boolean,
    color: String
  },
  components: {
    SwitchToggle
  },
  data() {
    return {
      isVisible: false
    }
  },
  created() {
    this.isVisible = this.visible;
  },
  methods: {
    setVisibility(visibility) {
      this.isVisible = visibility;
      this.$refs.switch.$refs.switchButton.checked = visibility;
    },
    toggleLayer() {
      this.isVisible = !this.isVisible;
      this.$emit('layer:toggle', {
        layersIds: [this.layerId],
        show: this.isVisible
      });
    }
  }
}
</script>

<style scoped lang="scss">
#layer-wc {
  width: 99%;
  height: 5%;
  padding: 5px 9.5px;
  background-color: #FFFFFF;

  .switch-button-name-layer {
    display: flex;
    width: 100%;
    padding: 0 2px;

    .name {
      height: 100%;
      width: 76%;
      text-align: justify;
      font-family: 'Roboto', sans-serif;
      font-weight: 500;
      font-size: 12px;
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      padding: 0 3%;
    }

    .color {
      width: 16px;
      height: 16px;
      border-radius: 2px;
    }
  }
}
</style>
